
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.footer-navigation {

    background-color: var(--blue-responsible-lighten-5);

    color: var(--blue-responsible-main)
}

.footer-navigation.mobile {

    display: block;

    grid-template-columns: repeat(9, minmax(0, 1fr));

    grid-template-rows: repeat(3, minmax(0, 1fr));

    background-color: var(--neutral-white);

    text-align: center
}

.footer-bottom--wrapper {

    background-color: var(--blue-responsible-main);

    padding-top: 1.25rem;

    padding-bottom: 1.25rem;

    padding-left: 1.25rem;

    padding-right: 1.25rem;

    color: var(--cyan-near-lighten-5)
}

.footer-bottom--content {

    display: flex;

    flex-direction: column;

    justify-content: center;

    padding-left: 1rem;

    padding-right: 1rem;

    text-align: center
}

@media (min-width: 1024px) {

    .footer-bottom--content {

        flex-direction: row
    }

    .footer-bottom--content {

        justify-content: space-between
    }

    .footer-bottom--content {

        padding-left: 5rem;

        padding-right: 5rem
    }
}

.footer-social {

    margin-left: auto;

    margin-right: auto;

    margin-bottom: 5rem;

    display: flex;

    flex-grow: 0;

    flex-direction: row
}

@media (min-width: 1024px) {

    .footer-social {

        margin-left: 0px;

        margin-right: 0px
    }

    .footer-social {

        margin-bottom: 0px
    }
}

.footer-logos {

    margin-left: auto;

    margin-right: auto;

    display: flex;

    flex-direction: row
}

@media (min-width: 1024px) {

    .footer-logos {

        margin-left: 0px;

        margin-right: 0px
    }

    .footer-logos {

        margin-bottom: 0px
    }
}
`;